<script setup lang="ts">
import { easeOut, motion } from 'motion-v'

const headlineVariants = {
  initial: { opacity: 0, y: '10%' },
  animate: { opacity: 1, y: 0, transition: { duration: 0.4, ease: easeOut } },
}

const buttonVariants = {
  initial: { opacity: 0, scale: 0.8 },
  animate: { opacity: 1, scale: 1, transition: { duration: 0.3, ease: easeOut } },
}
</script>

<template>
  <section class="3xl:px-0 mx-auto px-4 pt-12 pb-4 lg:max-w-screen-xl lg:pt-15 lg:pb-6">
    <div class="flex flex-col items-center rounded-3xl bg-[#F8F8F0] px-4 py-10 lg:px-8 lg:py-14">
      <motion.div
        class="mb-3 flex items-center"
        :initial="{ opacity: 0, y: 10 }"
        :while-in-view="{ opacity: 1, y: 0, transition: { duration: 0.4 } }"
      >
        <span class="grid size-12 place-content-center rounded-full bg-white p-1 shadow-sm">
          <img
            :src="`${S3_ASSETS_URL}/customer-review/g2.svg`"
            alt="G2"
            class="size-10"
          >
        </span>
        <span class="-ml-1 grid size-12 place-content-center rounded-full bg-white p-1 shadow-sm">
          <img
            :src="`${S3_ASSETS_URL}/customer-review/sh.svg`"
            alt="SpotHopper"
            class="size-10"
          >
        </span>
      </motion.div>

      <motion.div
        class="mb-3 flex items-center text-2xl text-orange-500"
        :initial="{ opacity: 0, y: 10 }"
        :while-in-view="{ opacity: 1, y: 0, transition: { delay: 0.1, duration: 0.4 } }"
        aria-label="Rated 4.8 out of 5 stars"
      >
        <UiIcon
          v-for="i in 5"
          :key="i"
          name="star-solid-rounded"
        />
      </motion.div>

      <motion.div
        class="pb-6"
        :variants="headlineVariants"
        initial="initial"
        while-in-view="animate"
      >
        <h3 class="mx-auto max-w-screen-sm text-balance text-center text-2xl font-medium lg:text-4xl">
          Rated 4.8/5 on G2 from 100+ reviews
        </h3>
        <p class="mx-auto mt-2 text-center text-base font-normal text-gray-600 lg:text-xl">
          Restaurant operators trust SpotHopper for easier marketing, stronger online presence,<br class="hidden lg:block"> and real business growth — see what verified users are saying.
        </p>
      </motion.div>

      <motion.div
        :variants="buttonVariants"
        initial="initial"
        while-in-view="animate"
      >
        <UiButton as-child>
          <a
            href="https://www.g2.com/products/spothopper/reviews"
            target="_blank"
            rel="noopener noreferrer"
          >
            View our G2 reviews
          </a>
        </UiButton>
      </motion.div>
    </div>
  </section>
</template>
